import React from "react";
import {Colors} from "../colors";

export const IconCloseDrawer = ({
  width = 28,
  height = 27,
  color = Colors.bw.black,
}: {
  color?: string;
  width?: number;
  height?: number;
}) => {
  return (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M18 6L6 18M6 6L18 18" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};
